import { Link } from "react-router-dom";

/** 8.13 — nosuchshop.13thav.com, an unverified domain, or /stores/<nobody>: one screen, never blank. */
export default function UnknownShop({ slug }) {
    return (
        <main className="app-frame flex min-h-screen flex-col items-center justify-center bg-page px-6 py-10 text-ink" data-testid="unknown-shop">
            <div className="flex w-full max-w-md flex-col items-start gap-4">
                <p className="text-[14px] font-semibold uppercase tracking-wide text-muted-ink">13thav</p>
                <h1 className="text-[28px] font-semibold leading-tight" data-testid="unknown-shop-title">This shop isn't open yet.</h1>
                <p className="text-[16px]" data-testid="unknown-shop-text">
                    {slug ? `There's no live shop at “${slug}”.` : `There's no live shop at ${window.location.host}.`} If it's yours, finish setting it up — if you're looking to start one, it takes a few minutes.
                </p>
                <Link to="/whitelabel" className="flex min-h-[48px] w-full items-center justify-center border border-ink bg-accent-brand px-4 text-[16px] font-semibold text-on-accent" data-testid="unknown-shop-start">
                    Start your own print shop
                </Link>
                <a href="https://13thav.com" className="flex min-h-[44px] items-center text-[16px] underline" data-testid="unknown-shop-home">Go to 13thav.com</a>
            </div>
        </main>
    );
}
